import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import CaseNumber from '../../CaseInformation/components/CaseNumber'
import ConfirmCaseNumber from '../../CaseInformation/components/ConfirmCaseNumber'
import {
  screenLoadingAction,
  addCaseAction,
  clearCaseAction,
  editCaseNumberAction,
  minPaymentAmountAction,
  amountOwingAction,
  caseSotIdAction,
  receiptDetailAction,
  caseTypeAction,
} from 'redux/actions'
import { getCaseOweAmountAction } from 'redux/reducers/apiReducers/caseOweAmountReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'

const AddCaseView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [caseNumberValid, setCaseNumberValid] = useState('')
  const [confirmCaseNumberValid, setConfirmCaseNumberValid] = useState('')
  const [errMsg, setErrMsg] = useState('')

  const [caseNumberError, setCaseNumberError] = useState('case_information.case_number_error')
  const [caseNumberJEINError, setCaseNumberJEINError] = useState('')
  const [confirmCaseNumberError, setConfirmCaseNumberError] = useState('case_information.confirm_case_number_error')

  const { caseNumber, confirmCaseNumber, cases, editCaseNumberStore } = useSelector((state) => state.app)


  useEffect(() => {
    try {
      dispatch(clearCaseAction())
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const onAddCase = () => {
    try {
      if (validateFields()) {
        setErrMsg('')
        dispatch(screenLoadingAction())
        dispatch(getServiceAvailableAction()).then((res) => {
          if (res['data']) {
            dispatch(getCaseOweAmountAction({ caseNumber: caseNumber }))
              .then((res) => {
                if (!res['validationFailureMessage'] && !isNaN(res['amountOwing']) && res['amountOwing'].toString().indexOf('.') !== -1) {
                  if (res['paymentAdjustmentMessage'] && res['paymentAdjustmentMessage'].includes('Full payment must be made.')) {
                    processPaymentFullCase(res)
                  } else {
                    caseNotFullProcess(res);
                  }
                } else {
                  setCaseNumberValid(false)
                  setCaseNumberJEINError(i18n.language === 'en' ? res['validationFailureMessage'] : res['validationFailureMessageFr'])
                }
                dispatch(screenLoadingAction())
              })
              .catch((e) => {
                setCaseNumberValid(false)
                setCaseNumberError('case_information.service_not_available_error')
                console.log(e)
                dispatch(screenLoadingAction())
              })
          }
          else {
            setErrMsg('case_information.service_not_available_error')
            dispatch(screenLoadingAction())
          }
        }).catch((e) => {
          console.log(e)
          setErrMsg('case_information.service_not_available_error')
          dispatch(screenLoadingAction())
        })
      }
    } catch (e) {
      console.log(e)
      setCaseNumberValid(false)
      setCaseNumberError('case_information.service_not_available_error')
    }
  }

  const processPaymentFullCase = (res) => {
    try {
      dispatch(
        addCaseAction({
          caseNumber,
          amountOwing: res['amountOwing'],
          paymentAmount: res['amountOwing'],
          minPaymentAmount: res['minimumPaymentAmount'],
          paymentAmountFull: true,
          caseSotId: res['caseSotId'],
          receiptDetail: res['receiptDetail'],
          caseType: res['caseSotValue'],
        })
      )
      dispatch(clearCaseAction())
      dispatch(editCaseNumberAction(''))
      history.push(`/${i18n.language}${t('routes.listed_cases')}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const caseNotFullProcess = (res) => {
    dispatch(amountOwingAction(res['amountOwing'].toString()))
    dispatch(minPaymentAmountAction(res['minimumPaymentAmount'].toString()))
    dispatch(caseTypeAction(res['caseSotValue']))
    dispatch(receiptDetailAction(res['receiptDetail']))
    dispatch(caseSotIdAction(res['caseSotId']))
    history.push(`/${i18n.language}${t('routes.case_owing_info')}`)
  }

  const validateFields = () => {
    try {
      validateCaseNumber(caseNumber)
      validateConfirmCaseNumber(confirmCaseNumber)
      if (caseNumber === '') {
        setCaseNumberValid(false)
      }
      if (confirmCaseNumber === '') {
        setConfirmCaseNumberValid(false)
      }
      return (
        caseNumberValid === true &&
        confirmCaseNumberValid === true &&
        caseNumber !== '' &&
        confirmCaseNumber !== '' &&
        caseNumber === confirmCaseNumber
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateCaseExist = (caseData) => {
    try {
      return cases.find((caseInfo) => caseInfo.caseNumber === caseData)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateCaseNumber = (caseNumber) => {
    try {
      setCaseNumberJEINError('')
      const regex = RegExp(/^\d+$/)
      if (caseNumber !== '') {
        if (regex.test(caseNumber)) {
          if (caseNumber.length > 0) {
            if (validateCaseExist(caseNumber)) {
              setCaseNumberValid(false)
              setCaseNumberError('case_information.case_number_exist')
            } else {
              setCaseNumberValid(true)
            }
          } else {
            setCaseNumberValid(false)
            setCaseNumberError('case_information.case_number_less')
          }
        } else {
          setCaseNumberValid(false)
          setCaseNumberError('case_information.case_number_invalid')
        }
      } else {
        setCaseNumberValid(false)
        setCaseNumberError('case_information.case_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateConfirmCaseNumber = (number) => {
    try {
      if (number && number === caseNumber) {
        setConfirmCaseNumberValid(true)
      } else {
        setConfirmCaseNumberValid(false)
        setConfirmCaseNumberError('case_information.confirm_case_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <h2>{t('cases_list.or_add_another_restitution')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <CaseNumber
            validateCaseNumber={validateCaseNumber}
            caseNumberError={caseNumberError}
            caseNumberValid={caseNumberValid}
            caseNumberJEINError={caseNumberJEINError}
            setIsError={setIsError}
          />
          <ConfirmCaseNumber
            validateConfirmCaseNumber={validateConfirmCaseNumber}
            confirmCaseNumberError={confirmCaseNumberError}
            confirmCaseNumberValid={confirmCaseNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className="form-group has-error">
        <button
          className="btn-lg btn-default"
          style={{ marginBottom: errMsg === '' ? '' : '5px' }}
          onClick={onAddCase}
          value={t('cases_list.add_case')}
          name={t('cases_list.add_case')}
        >
          {t('cases_list.add_case')}
        </button>{' '}
        {errMsg === '' ? '' : <i className="fa fa-exclamation-circle" aria-hidden="true" />}
        <div className="help-block">{t(errMsg)}</div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(AddCaseView)
